import React from 'react';
import { InstagramIcon, MailIcon, GlobeIcon } from 'lucide-react';
import { INSTAGRAM_URL, SUPPORT_EMAIL, WEBSITE_URL } from '../data/contact';
const links = [{
  icon: MailIcon,
  label: SUPPORT_EMAIL,
  href: `mailto:${SUPPORT_EMAIL}`,
  external: false
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  href: INSTAGRAM_URL,
  external: true
}, {
  icon: GlobeIcon,
  label: 'Official website',
  href: WEBSITE_URL,
  external: true
}];
export function SiteFooter() {
  return <footer className="border-t border-night-600 bg-night-950 py-12 sm:py-14" data-id="element-292" data-mp="3dei5e4kx7hmt">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-293" data-mp="38ggnhmz8docx">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-294" data-mp="33hvlpj4bywmd">
          <div className="max-w-md" data-id="element-295" data-mp="2ykdjebktjfnc">
            <p className="font-display text-2xl leading-tight text-cream" data-id="element-296" data-mp="2ylevmjdkm86n">
              Jazz Teacher&rsquo;s <span className="text-amber" data-id="element-297" data-mp="11qsaarmm9e0r">Arsenal&trade;</span>
            </p>
            <p className="mt-2 text-sm text-cream-muted" data-id="element-298" data-mp="wta4vb7t5gxi">
              The complete system for professional jazz educators.
            </p>
            <p className="mt-5 font-serif text-base italic leading-snug text-cream-soft" data-id="element-299" data-mp="15t80a5wsua5z">
              Because teaching jazz shouldn&rsquo;t cost you every evening of the week.
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-col gap-3" data-id="element-300" data-mp="10rse2aivxxm0">
            {links.map(({
            icon: Icon,
            label,
            href,
            external
          }) => <a key={label} href={href} {...external ? {
            target: '_blank',
            rel: 'noopener noreferrer'
          } : {}} className="flex items-center gap-3 text-sm text-cream-soft transition-colors duration-150 ease-out hover:text-amber" data-id="element-301" data-mp="1oieat5nfvvgp">
                <Icon className="h-4 w-4 text-amber" aria-hidden="true" data-id="element-302" data-mp="1jpbq7n0n3wcn" />
                {label}
              </a>)}
          </nav>
        </div>

        <p className="mt-10 border-t border-night-600 pt-6 text-[10px] uppercase tracking-label text-cream-muted sm:text-[11px]" data-id="element-303" data-mp="2c6nrxu9pjv1i">
          &copy; Jazz Teacher&rsquo;s Arsenal&trade; 2026 &mdash; All rights reserved.
        </p>
      </div>
    </footer>;
}